import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './ManagedWidget.css';
import React, { useContext, useState, useRef, useEffect } from 'react';
import debounce from 'lodash.debounce';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, canUseDOM, getPageThemeColors, getColorByTheme } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
var ManagedWidget = function ManagedWidget(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var _fields$data = fields.data,
    layoutStyleAnalytics = _fields$data.layoutStyle,
    interactionWithWidgetAnalytics = _fields$data.interactionWithWidget,
    copyCodeAnalytics = _fields$data.copyCode;
  var codeDescription = get(fields, 'data.datasource.codeDescription.jss.value');
  var iframeBaseLink = (canUseDOM ? window.location.origin : '') + get(fields, 'data.datasource.baseUrl.jss.value.href', '');
  var makeIFrameHTML = function makeIFrameHTML(_ref2) {
    var type = _ref2.type,
      color = _ref2.color;
    var params = '';
    var isDesktop = window.innerWidth >= 768;
    if (canUseDOM && isDesktop) {
      params = "type=".concat(encodeURIComponent(type), "&");
    }
    return "<iframe ".concat(isDesktop ? 'style="border: 1px solid #C7C7C7;"' : 'frameborder="0" width="325"', " src=\"").concat(iframeBaseLink, "?").concat(params, "color=").concat(color.slice(1), "\"></iframe>");
  };
  var layoutStyles = get(fields, 'data.datasource.layoutStyle.styles', []);
  var baseLayoutStyle = get(layoutStyles, '0.value.jss.value');
  var baseLayoutStyleTitle = get(layoutStyles, '0.title.jss.value');
  var baseColor = '#6E2B62';
  var _useState = useState(baseLayoutStyle),
    _useState2 = _slicedToArray(_useState, 2),
    selectedLayoutStyle = _useState2[0],
    setLayoutStyle = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    iframeHTML = _useState4[0],
    setIFrameHTML = _useState4[1];
  var _useState5 = useState(baseColor),
    _useState6 = _slicedToArray(_useState5, 2),
    layoutColor = _useState6[0],
    setLayoutColor = _useState6[1];
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var variables = BackgroundColorHex ? {
    "--managed-widget-primary-color": BackgroundColorHex,
    "--managed-widget-primary-active-color": ActiveColorHex,
    "--managed-widget-color": ColorHex
  } : {
    "--managed-widget-primary-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--managed-widget-primary-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--managed-widget-color": getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  var iframeURLRef = useRef();
  var dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  var mapDictionary = dictionaryValues.reduce(function (map, currentValue) {
    return map.set(currentValue.key.jss.value, currentValue.phrase.jss.value);
  }, new Map());
  var setDebounceLayoutColor = debounce(setLayoutColor, 500);
  var setNewIFrame = function setNewIFrame() {
    setIFrameHTML(makeIFrameHTML({
      type: selectedLayoutStyle,
      color: layoutColor
    }));
  };
  var handleLaoutStyleClick = function handleLaoutStyleClick(e, layoutStyle) {
    e.preventDefault();
    tealiumClickFunc(tealiumMergeClickData(layoutStyleAnalytics, params), layoutStyle.value.jss.value);
    setLayoutStyle(layoutStyle.value.jss.value);
  };
  var renderLayoutsOptions = function renderLayoutsOptions() {
    return layoutStyles.map(function (layoutStyle, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "m-widget-layouts__item",
        onClick: function onClick(e) {
          return handleLaoutStyleClick(e, layoutStyle);
        },
        key: index
      }, /*#__PURE__*/React.createElement("input", {
        tabIndex: 0,
        onKeyPress: function onKeyPress(event) {
          if (event.key === "Enter" || event.key === "NumpadEnter") {
            handleLaoutStyleClick(event, layoutStyle);
          }
        },
        type: "radio",
        value: layoutStyle.value.jss.value,
        name: "m-widget-layout-style",
        checked: layoutStyle.value.jss.value === selectedLayoutStyle
      }), /*#__PURE__*/React.createElement("label", {
        className: "body-small m-widget-layouts__label"
      }, /*#__PURE__*/React.createElement("span", {
        className: "m-widget-layouts__label-text"
      }, layoutStyle.title.jss.value)));
    });
  };
  var copy = function copy() {
    var fallback = function fallback() {
      iframeURLRef.current.select();
      if (canUseDOM) {
        document.execCommand('copy');
        tealiumClickFunc(tealiumMergeClickData(copyCodeAnalytics, params));
      }
    };
    if (navigator.clipboard) {
      try {
        navigator.clipboard.writeText(iframeHTML);
        tealiumClickFunc(tealiumMergeClickData(copyCodeAnalytics, params));
      } catch (error) {
        fallback();
      }
    } else {
      fallback();
    }
  };
  useEffect(function () {
    if (canUseDOM) {
      var windowResizeHandler = debounce(function () {
        return setNewIFrame();
      }, 500);
      window.addEventListener('resize', windowResizeHandler);
      return function () {
        return window.removeEventListener('resize', windowResizeHandler);
      };
    }
  }, []);
  useEffect(function () {
    return setNewIFrame();
  }, [selectedLayoutStyle]);
  if (!fields) {
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[ManagedWidget component is empty: please provide datasource]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-widget offset-xl-1",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-widget-layouts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-widget-layouts__head"
  }, mapDictionary.get('LayoutStyle')), /*#__PURE__*/React.createElement("div", {
    className: "m-widget-layouts__body"
  }, renderLayoutsOptions())), /*#__PURE__*/React.createElement("div", {
    className: "m-widget-color"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-widget-color__head"
  }, mapDictionary.get('PickColor')), /*#__PURE__*/React.createElement("div", {
    className: "m-widget-color__body"
  }, /*#__PURE__*/React.createElement("input", {
    id: "m-widget-color-picker",
    type: "color",
    value: layoutColor,
    className: "m-widget-color__picker-control",
    onChange: function onChange(e) {
      setDebounceLayoutColor(e.currentTarget.value.toUpperCase());
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    }
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "m-widget-color-picker",
    className: "m-widget-color__picker",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-widget-color__picker-value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-widget-color__picker-square",
    style: {
      backgroundColor: layoutColor
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "m-widget-color__picker-hex"
  }, layoutColor))), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: function onClick() {
      setNewIFrame();
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    }
  }, mapDictionary.get('UpdateWidget')))), /*#__PURE__*/React.createElement("div", {
    className: "m-widget__iframe",
    key: iframeHTML,
    dangerouslySetInnerHTML: {
      __html: iframeHTML
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "widget-code"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "h4 widget-code__title"
  }, mapDictionary.get('WidgetCode')), /*#__PURE__*/React.createElement("div", {
    className: "widget-code__desc"
  }, codeDescription), /*#__PURE__*/React.createElement("textarea", {
    dir: "ltr",
    className: "widget-code__txt-area",
    ref: iframeURLRef,
    rows: 4,
    disabled: true,
    value: iframeHTML
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary widget-code__copy",
    onClick: copy
  }, mapDictionary.get('CopyCode'))))));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    className = _ref3.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className, " module-group"),
    "data-cy": "rich-text"
  }, children);
};
var commonStyles = "cl0b85t";
var ltrStyles = "l1ifxkrs";
var rtlStyles = "r1ya69i3";
export default ManagedWidget;